import { render, staticRenderFns } from "./DualEndpointStatus.vue?vue&type=template&id=646342cd&scoped=true&"
import script from "./DualEndpointStatus.vue?vue&type=script&lang=js&"
export * from "./DualEndpointStatus.vue?vue&type=script&lang=js&"
import style0 from "./DualEndpointStatus.vue?vue&type=style&index=0&id=646342cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646342cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('646342cd')) {
      api.createRecord('646342cd', component.options)
    } else {
      api.reload('646342cd', component.options)
    }
    module.hot.accept("./DualEndpointStatus.vue?vue&type=template&id=646342cd&scoped=true&", function () {
      api.rerender('646342cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/DualEndpointStatus.vue"
export default component.exports